import * as Yup from 'yup'

export const CustomerContactSchema = Yup.object().shape({
    id: Yup
        .number(),

    customer_id: Yup
        .string(),

    first_name: Yup
        .string()
        .label('First Name')
        .min(1)
        .required()
        .nullable(),

    last_name: Yup
        .string()
        .label('Last Name')
        .nullable(),

    phone_number: Yup
        .string()
        .label('Phone Number')
        .nullable(),

    email_address: Yup
        .string()
        .email()
        .label('Email Address')
        .nullable(),

    position: Yup
        .string()
        .label('Position')
        .nullable(),

})
export const CustomerSchema = Yup.object().shape({
    invoice_email: Yup
        .string()
        .email()
        .label('Invoice Email')
        .nullable(),

    company_email: Yup
        .string()
        .email()
        .label("Company Email")
        .nullable(),

    schedule_contact_email: Yup
        .string()
        .email()
        .label("Schedule Contact Email")
        .nullable(),
        
    web_page: Yup
        .string()
        .url()
        .label("Web Page")
        .nullable(),

    company_name: Yup
        .string()
        .label('Company Name')
        .min(1)
        .required(),

    address_line_1: Yup
        .string()
        .label('Address Line 1')
        .nullable(),

    address_line_2: Yup
        .string()
        .label('Address Line 2')
        .nullable(),

    address_line_3: Yup
        .string()
        .label('Address Line 3')
        .nullable(),

    city: Yup
        .string()
        .label('City')
        .nullable(),

    state: Yup
        .string()
        .label('State')
        .max(2)
        .nullable(),

    zip_code: Yup
        .string()
        .label('Zip Code')
        .max(10)
        .min(5)
        .nullable(),

    business_phone: Yup
        .string()
        .label('Business Phone')
        .nullable(),

    pricing_email: Yup
        .string()
        .email()
        .label("Pricing Email")
        .nullable(),

    telephone_ext: Yup
        .string()
        .label('Telephone Ext')
        .nullable(),

    fax_number: Yup
        .string()
        .label('Fax Number')
        .nullable(),

    note: Yup
        .string()
        .label('Note')
        .nullable(),

    customer_no: Yup
        .string()
        .label('Customer No')
        .nullable(),

    is_active: Yup
        .bool()
        .label('Active'),

    is_invoice_by_email: Yup
        .bool()
        .label('Invoice by Email'),

    is_invoice_by_fax: Yup
        .bool()
        .label('Invoice by Fax'),

    is_invoice_by_mail: Yup
        .bool()
        .label('Invoice by Mail'),

    is_credit_app: Yup
        .bool()
        .label('Is Credit App'),

    profile_upload: Yup.mixed()
        .test(
            'fileName',
            'Error processing selected file. Please Try again.',
            (file) => !file || file?.name
        )
        .test(
            'fileType',
            'Bad file type, please select a png or jpg.',
            (file) =>
                !file || ["image/png", "image/jpg", "image/jpeg"].includes(file.type)
        )
        .label('File'),

    customer_contacts: Yup.array().of(CustomerContactSchema)
})
